import { DSPageSection, DSPageSections } from 'shared-definitions/types'
import { ApiPostSections, ApiSectionItem } from 'data-source/types.wp'
import { normalizeId } from 'shared-code/string'

function mapSection(input: ApiSectionItem): DSPageSection {
  return {
    label: input.label,
    anchor: normalizeId(input.anchor),
    children: input.children?.map(mapSection) ?? [],
  }
}

export function postSectionsMapper(input: ApiPostSections): DSPageSections {
  return {
    title: input.title,
    items: input.data.map(mapSection),
  }
}
